import { render, staticRenderFns } from "./Pph.vue?vue&type=template&id=31441456&scoped=true"
import script from "./Pph.vue?vue&type=script&lang=js"
export * from "./Pph.vue?vue&type=script&lang=js"
import style0 from "./Pph.vue?vue&type=style&index=0&id=31441456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31441456",
  null
  
)

export default component.exports